<template>
    <el-card class="box-card mt-2 booking-list-box" v-bind:class="{ 'warning-card' : enquiry.iswarning}"   :key="enquiry.id">
        <template #header>
            <el-row >
                <el-col :span="12">
                    <el-checkbox class="mr-2" size="small" label="" name="type"  @change="selectchange" v-if="data.permissions.select" />
                    <el-tag class="mr-2 bdark" effect="dark" >CDM{{enquiry.id}}</el-tag>
                    <el-tag class="mr-2" style="" >
                        {{enquiry.type}}</el-tag>
                    <a
                        v-if="enquiry.external_quotation_link"
                        :href="enquiry.external_quotation_link"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="external-quotation-link"
                    >
                        <el-tag class="mr-2">{{ enquiry.external_quotation_id }}</el-tag>
                    </a>
                    <el-tag class="mr-2" v-else-if="enquiry.external_quotation_id">
                        {{ enquiry.external_quotation_id }}</el-tag>

                    <el-tag class="mr-2" type="danger" effect="dark" v-if="enquiry.is_hot==1" >
                        Hot
                    </el-tag>
                    <lead-score-badge
                        class="mr-2"
                        :score="enquiry.lead_score"
                        :type="enquiry.lead_score_type"
                        :label="enquiry.lead_score_label"
                    />
                    <el-tag class="mr-2" style="" >
                        {{enquiry.enq_date}}</el-tag>
                    <el-tag class="mr-2" v-if="enquiry.follow_up_at!=null" >
                        FW-{{enquiry.follow_up_at}}
                    </el-tag>
                    <el-tag class="mr-2" v-if="enquiry.enq_source!=''" >
                        {{enquiry.enq_source}}
                    </el-tag>



                </el-col>
                <el-col :span="12" >
                    <el-row justify="end">
                        <el-tag class="mr-2" v-if="enquiry.last_contacted!=''" >
                            {{enquiry.last_contacted}}
                        </el-tag>
                        <el-tag
                            v-if="enquiry.no_action_since"
                            class="mr-2 no-action-tag"
                            effect="dark"
                            :type="noActionTagType"
                        >
                            No action · {{ enquiry.no_action_hours }}h ({{ enquiry.no_action_since }})
                        </el-tag>
                        <el-tag class="mr-2" effect="dark" :type="enquiry.status=='Pending'? 'info' : enquiry.status=='InProgress'? 'warning' : 'danger'" >{{enquiry.status}}</el-tag>
                        <el-tag class="mr-2" style="" v-if="enquiry.assignedto!=null">
                            <el-avatar class="mr-2" :size="20" :src="'https://crm.pickotrip.com/images/agents/'+enquiry.assignedto+'.jpg'" />
                            {{enquiry.assignedto}}</el-tag>
                        <el-tag
                            v-if="enquiry.can_toggle_read"
                            class="mr-2"
                            effect="dark"
                            :type="enquiry.is_read ? 'info' : 'danger'"
                            @click="toggleRead"
                        >
                            {{ enquiry.is_read ? 'Mark as Unread' : 'Mark as Read' }}
                        </el-tag>
                        <el-tag class="mr-2 bdark" effect="dark"  @click="openenquiry(enquiry.viewlink)">
                            View
                        </el-tag>
                       <enquiry-action :enquiry="enquiry" :user="data.user" :languages="data.languages" @actionevent="$emit('actionevent')"></enquiry-action>


                    </el-row>
                </el-col>

            </el-row>


        </template>
        <div  class="booking-contents">
            <div>
                <p class="lbl">Name</p>
                <p class="vlv">{{enquiry.name}}</p>
            </div>
            <el-divider direction="vertical" />
            <div>
                <p class="lbl">Mobile</p>
                <p class="vlv">{{enquiry.mobile}}</p>
            </div>
            <el-divider direction="vertical" />
            <div>
                <p class="lbl">Destinations</p>
                <p class="vlv">{{enquiry.destinations}}</p>
            </div>
            <el-divider direction="vertical" />
            <div>
                <p class="lbl">Departure Date</p>
                <p class="vlv">{{enquiry.departuredate}}</p>
            </div>
            <el-divider direction="vertical" />
            <div>
                <p class="lbl">Pax</p>
                <p class="vlv">{{ enquiry.pax || '-' }}</p>
            </div>
            <el-divider direction="vertical" />
            <div>
                <p class="lbl">Quotes</p>
                <p class="vlv">{{enquiry.quotations_count}}</p>
            </div>
            <el-divider direction="vertical" />
            <div v-if="enquiry.lead_score !== null && enquiry.lead_score !== undefined">
                <p class="lbl">AI Score</p>
                <p class="vlv">
                    <lead-score-badge
                        :score="enquiry.lead_score"
                        :type="enquiry.lead_score_type"
                        :label="enquiry.lead_score_label"
                    />
                </p>
            </div>
            <el-divider v-if="enquiry.lead_score !== null && enquiry.lead_score !== undefined" direction="vertical" />
            <div>
                <p class="lbl">Remark</p>
                <p class="vlv" v-html="enquiry.remark"></p>
            </div>

        </div>


        <div v-if="enquiry.warning!=''" class="warning-content">
            <p v-html="enquiry.warning"></p>
        </div>
    </el-card>
</template>

<script>
import  { ElCheckbox,ElInput,ElSpace,ElPagination,ElText,ElCollapseItem,ElCollapse,ElSelect, ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton  } from 'element-plus'
import 'element-plus/dist/index.css'
import moment from 'moment'
import LeadScoreBadge from './Components/LeadScoreBadge.vue'
export default {
    name: "ListCard",
    emits: ["actionevent"],
    components: { LeadScoreBadge, ElCheckbox,ElInput,ElSpace,ElPagination,ElText,ElCollapseItem,ElCollapse,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton },
    props:{
        enquiry: {
            type: Object,
            default () {
                return null
            }
        },
        data: {
            type: Object,
            default () {
                return null
            }
        },

    },
    methods:{

        toggleRead() {
            const markAsRead = !this.enquiry.is_read;
            let currentObj = this;
            axios.post('/enquiry/toggle-read', {
                id: this.enquiry.id,
                read: markAsRead,
            }).then(function (response) {
                Object.assign(currentObj.enquiry, response.data.data ?? response.data);
                toastr.success(markAsRead ? 'Marked as read.' : 'Marked as unread.');
                currentObj.$emit('actionevent');
            }).catch(function () {
                toastr.error('Unable to update read status.');
            });
        },
        openenquiry(link){
            const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
            const separator = link.includes('?') ? '&' : '?';
            window.open(link + separator + 'return=' + returnUrl, '_blank');
        },
        selectchange(value){

            this.$emit('selectchange',this.enquiry.id,value)
        }
    },
    computed: {
        noActionTagType() {
            const bucket = this.enquiry.no_action_bucket;
            if (bucket === 'over_24') {
                return 'danger';
            }
            if (bucket === '12_24') {
                return 'warning';
            }
            if (bucket === '1_12') {
                return 'warning';
            }
            return 'info';
        }
    }
}
</script>

<style scoped>
.external-quotation-link {
    text-decoration: none;
    color: inherit;
}
</style>
